// LocalStorage-backed replacement for electron-store.
// Provides a get/set/delete interface used by the ported vehicles module.

const NAMESPACE = 'navgcs:';

class BrowserStore {
    constructor(namespace = NAMESPACE) {
        this.ns = namespace;
    }

    _key(k) {
        return this.ns + k;
    }

    get(key, defaultValue = undefined) {
        try {
            const raw = window.localStorage.getItem(this._key(key));
            if (raw === null || raw === undefined) return defaultValue;
            return JSON.parse(raw);
        } catch (err) {
            console.warn('BrowserStore.get error', key, err);
            return defaultValue;
        }
    }

    set(key, value) {
        try {
            window.localStorage.setItem(this._key(key), JSON.stringify(value));
        } catch (err) {
            console.warn('BrowserStore.set error', key, err);
        }
    }

    delete(key) {
        try {
            window.localStorage.removeItem(this._key(key));
        } catch (err) {
            console.warn('BrowserStore.delete error', key, err);
        }
    }
}

const store = new BrowserStore();

export default store;
export { BrowserStore };
